import axios from 'axios';

import {hostStoreMock} from 'hostStoreMock';

export const apiConfig = {
    API_URL: '/ms/',
    hostStore: hostStoreMock,
    instanceDyChoose: axios.create(),
    instanceDyEngagement: axios.create(),
    instanceGusaBackend: axios.create(),
    instancePopupBackend: axios.create(),
};

export enum HTTP_REQUEST_HEADER {
    CONTENT_TYPE = 'Content-Type',
    STORE = 'store',
    AUTHORIZATION = 'Authorization',
    X_STORE_ID = 'X-Store-Id',
    IS_REACT = 'is-react',
    PRAGMA = 'Pragma',
    WEBSITE = 'website',
    X_WEBSITE_ID = 'X-Website-Id',
    X_VISITOR_ID = 'X-Visitor-Id',
}

export enum HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE {
    MULTIPART_FORM_DATA = 'multipart/form-data',
    APPLICATION_JSON = 'application/json',
}
